import { FunctionComponent, PropsWithChildren, ReactElement } from 'react';

import { Box } from '@mui/material';
import { Form, withFormik } from 'formik';
import compose from 'lodash/fp/compose';

import { withHigherOrderComponent } from '../../../../../../../shared/components/with-higher-order-component/with-higher-order-component';
import { useNoSubmit } from '../../../../../../../shared/hooks/use-no-submit/use-no-submit.hook';
import Filter from '../../../../../../shared/components/filter/Filter';
import { StatisticsFiltersFormikModel } from '../models/statistics-filters-formik.model';
import { StatisticsFilterProps } from '../types/statistics-filter-props.type';
import DisplayDropdown from './display-dropdown';
import IntervalDropdown from './interval-dropdown';
import ViewByDropdown from './view-by-dropdown';

const StatisticsFilter: FunctionComponent<StatisticsFilterProps> = (
  props: PropsWithChildren<StatisticsFilterProps>
): ReactElement => {
  const { children, handleSubmit } = props;

  return (
    <Box sx={{ mt: '48px' }}>
      <Form onSubmit={handleSubmit}>
        <Filter title="CONFIGURATION">{children}</Filter>
      </Form>
    </Box>
  );
};

export default withFormik<
  Record<string, unknown>,
  StatisticsFiltersFormikModel
>({
  handleSubmit: useNoSubmit(),
})(
  compose(
    withHigherOrderComponent(DisplayDropdown),
    withHigherOrderComponent(ViewByDropdown),
    withHigherOrderComponent(IntervalDropdown)
  )(StatisticsFilter)
);
